import { reflectKeys } from "@utils/key.reflactor.ts";
export const ROUTE_ACCESS = reflectKeys([
  "PUBLIC",
  "AUTHENTICATED",
  "TWO_FA_AUTHENTICATED",
  "PRIVILEGED_USER_TWO_FA_AUTHENTICATED",
  "NOT_AUTHENTICATED",
]);
export const ROUTE_STORE = "route";
export const LOCALE_DEFAULT = {
  DEFAULT_UPPERCASE: "EN",
  DEFAULT_LOWERCASE: "en",
};
export const OBJECT_TYPE = {
  ASSIGNMENT: "assignment",
  ASSESSMENT: "assessment",
  MODULE: "module",
  ALS_SESSION: "als-session",
};
